var map = {
	"./de-flag.svg": 4270,
	"./en-gb-flag.svg": 8203,
	"./en-us-flag.svg": 8492,
	"./es-es-flag.svg": 5515,
	"./es-mx-flag.svg": 7433,
	"./fr-ca-flag.svg": 5302,
	"./fr-fr-flag.svg": 366,
	"./ja-flag.svg": 2131,
	"./ko-flag.svg": 8996,
	"./pt-br-flag.svg": 3822,
	"./pt-pt-flag.svg": 795,
	"./ru-flag.svg": 2817,
	"./ta-in-flag.svg": 2982,
	"./unknown-flag.svg": 1562,
	"./zh-cn-flag.svg": 9144,
	"./zh-hk-flag.svg": 8465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9051;